import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import MaterialIcon from './MaterialIcon';
export default function MaterialIconPreload() {
    return (_jsxs(Hidden, { children: [_jsx(MaterialIcon, { icon: "search", iconPack: "icons-outlined" }), _jsx(MaterialIcon, { icon: "search", iconPack: "symbols-outlined" })] }));
}
const Hidden = styled.div `
	width: 0;
	height: 0;
	overflow: hidden;
	visibility: hidden;
	position: absolute;
	top: -99999px;
	left: -99999px;
`;
//# sourceMappingURL=MaterialIconPreload.js.map